import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ChevronRight } from 'lucide-react';

const SITE_URL = 'https://innovation.valorizasm.com';

/**
 * Visible breadcrumb trail + BreadcrumbList JSON-LD.
 * items: [{ label, to? }] — the last item should omit `to` (current page).
 */
export default function Breadcrumb({ items }) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.label,
      ...(it.to ? { item: `${SITE_URL}${it.to === '/' ? '' : it.to}` } : {}),
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <nav aria-label="breadcrumb" data-testid="breadcrumb" className="flex items-center gap-1.5 text-xs text-gray-500 dark:text-white/40 mb-8 flex-wrap">
        {items.map((it, i) => (
          <span key={i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight size={12} />}
            {it.to ? (
              <Link to={it.to} className="hover:text-[#8DC21F] transition-colors">{it.label}</Link>
            ) : (
              <span className="text-gray-700 dark:text-white/70 font-medium">{it.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}
